import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import * as BullCache from "../../util/BullCache";
import "../custom.css";
import { AdminService } from '../../services/AdminService';


function LiveUsers() {

  const [loading, setLoading] = useState(false);
  const [userlist, setUserlist] = useState([]);

  var user = BullCache.getFromCache("user");
  useEffect(() => {
        setLoading(true);
      const timeoutId = setTimeout(() => {
        getCustomers();
    }, 2000);
    return () => {
        clearTimeout(timeoutId); 
        };
   
  }, []);

  function getCustomers() {
    setLoading(true);
    setUserlist([]);
   AdminService.getLiveUsers({ 'adminId': user.adminId }).then(resp => {
      setLoading(false);
      if (resp.code === 1) {
        if (resp.data.d.length > 0) {
          setUserlist(resp.data.d);
        } 
      }
    });
  }

  const handleSubmit = () => {
     getCustomers();
  };


  const columns = [
    { title: 'LOGIN ID', data: 'userName', className: 'col-1 font-bold fss-09' },
    {
      title: 'NAME', data: 'firstName', className: 'col-2 font-bold text-nowrap fss-09'
    },
    { title: 'Type', data: 'adminType', className: 'col-1 font-bold fss-09',
            render: (data, type, full, meta) => full.adminType != null ? full.adminType : 'USER'
    },
     {
      title: 'LOGIN TIME', data: 'lastLogin', className: 'col-2 font-bold text-nowrap fss-09'
    },
  
  ];

  return (
    <div className='container-fluid mb-5'>
      <div className='text-right'>
        <Button variant="success" size="sm" className='mt-2 mb-1' onClick={handleSubmit}>
                    <b className="fss-08" >REFRESH</b>
        </Button>
      </div>
      <Card className='mt-1 ' >
        <Card.Body className='ps-0 pe-0'>
        <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : 
              <DataTable id="table" className="mt-1 table table-striped bg-secondary-row fss-09"
                data={userlist} columns={columns}
              />
            }
          </div>

        </Card.Body>
      </Card>

     

    </div>
  )

}

export default LiveUsers;